import _defineProperty from "/app/node_modules/.pnpm/next@12.3.3_4afada721a4a39e35a1a66028f2134fd/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useSelector } from 'react-redux';
import { Text } from '@vinted/web-ui';
import useTranslate from 'hooks/useTranslate';
import { registerGoogleUser } from 'data/api/account';
import * as selectors from 'state/auth/selectors';
import { getFingerprint } from 'libs/utils/fingerprint';
import RegisterForm from '../RegisterForm';
import { useRegistrationTracking } from '../hooks/useRegistrationTracking';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

const GoogleRegister = _ref => {
  let {
    idToken,
    realName,
    email
  } = _ref;
  const translate = useTranslate();
  const referrerId = useSelector(selectors.getReferrerId);
  const trackRegistrationEvents = useRegistrationTracking();

  async function handleFormSubmit(data) {
    const fingerprint = await getFingerprint();
    const response = await registerGoogleUser(_objectSpread(_objectSpread({
      agreeRules: true
    }, data), {}, {
      referrerId,
      token: idToken,
      fingerprint
    }));
    await trackRegistrationEvents({
      response,
      authType: 'google',
      email: data.email
    });
    return response;
  }

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("div", {
      className: "u-ui-padding-horizontal-large",
      children: /*#__PURE__*/_jsx(Text, {
        id: "auth_modal_title",
        text: translate('auth.external_register.title'),
        type: Text.Type.Heading,
        alignment: Text.Alignment.Center,
        width: Text.Width.Parent
      })
    }), /*#__PURE__*/_jsx(RegisterForm, {
      email: email,
      realName: realName,
      onSubmit: handleFormSubmit
    })]
  });
};

export default GoogleRegister;